import { call } from 'redux-saga/effects';
import ApiService from 'services/ApiService';
function* resolveStatisticalPersonalityId(holderEntry) {
    const requestUrl = '/api/Statistics/resolveStatisticalPersonalityId';
    const response = yield call(ApiService.regionalRequest, requestUrl, {
        method: 'POST',
        body: holderEntry
    });
    return response.statisticalPersonalityId;
}
export default {
    resolveStatisticalPersonalityId
};
